<template>
  <div class="dropdown-menu" :class="classes">
    <div @click.stop="isActive = !isActive" class="dropdown-menu__activator">
      <slot name="activator"></slot>

      <div v-if="caret" class="dropdown-menu__caret">
        <SvgIcon size="14" name="caret-down" />
      </div>
    </div>

    <transition :name="transition">
      <div
        v-if="isActive"
        ref="content"
        class="dropdown-menu__content"
        @click="isActive = false"
      >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    caret: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    transition: {
      type: String,
      default: "slide-y-transition"
    }
  },

  data: () => ({
    isActive: false
  }),

  computed: {
    classes() {
      return {
        "dropdown-menu_active": this.isActive
      };
    }
  },

  methods: {}
};
</script>

<style lang="scss">
.dropdown-menu {
  position: relative;
  display: inline-flex;
  align-items: center;

  &__activator {
    cursor: pointer;
    transition: $secondary-transition;
    padding: 4px 12px 4px 4px;
    user-select: none;
    display: inline-flex;
    align-items: center;
    flex: 1 1 auto;

    > * {
      flex: 1 1 auto;
    }

    &:hover,
    .dropdown-menu_active & {
      background: rgba(#fff, 0.15);
    }
  }

  &__content {
    position: absolute;
    top: 100%;
    z-index: 10;
    left: 0;
    right: 0;
    padding-top: 2px;
  }

  &__caret {
    transition: $secondary-transition;
    margin-left: 12px;
    color: #1480b2;

    .dropdown-menu_active & {
      color: #fff;
      transform: rotate(-90deg);
    }
  }
}

.menubar {
  .dropdown-menu,
  .dropdown-menu__activator {
    display: flex !important;
    flex: 1 1 100% !important;
  }

  .dropdown-menu__activator {
    padding: 8px 30px;
  }
}

.dropdown-list {
  background: #000a25;
  border-bottom: 2px solid #1480b2;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);

  .btn {
    text-transform: none;
    font-size: 14px;
    font-weight: normal;
    padding: 5px 15px;
    border-radius: 0;

    &:hover {
      background: rgba(#fff, 0.15);
    }

    &.active {
      background: #1e2135;
      color: #1480b2;
    }

    justify-content: flex-start;

    &__content {
      justify-content: flex-start;
    }
  }
}
</style>
